import styles from './StatCard.module.scss'

function StatCard({ icon, title, value, delta, deltaDirection }) {
  const deltaClass =
    deltaDirection === 'up'
      ? styles.delta_up
      : deltaDirection === 'down'
        ? styles.delta_down
        : ''

  return (
    <div className={styles.card}>
      <div className={styles.icon}>
        {typeof icon === 'string' ? icon.slice(0, 2).toUpperCase() : icon}
      </div>
      <div className={styles.body}>
        <div className={styles.title}>{title}</div>
        <div className={styles.value}>{value ?? '—'}</div>
        {delta != null ? (
          <div className={`${styles.delta} ${deltaClass}`}>{delta}</div>
        ) : null}
      </div>
    </div>
  )
}

export default StatCard
